import performance from "./performance.js"
import member from "./member.js"
import author from "./author.js"
import play from "./play.js"
import troupe from "./troupe.js"
import { base, toJS } from '../../../api/airtable.js'

const state = {
  active: '',
}

const getters = {}

const actions = {
  load({commit, dispatch}, payload) {
    switch(payload.type) {
      case 'CAST':
        commit('SET_ACTIVE', 'cast')
        base('Cast Members').find(payload.id, (err, rec) =>
          dispatch('member/setup', toJS(rec))
        )
        break
      case 'AUTHOR':
        commit('SET_ACTIVE', 'author')
        base('Authors').find(payload.id, (err, rec) =>
          dispatch('author/setup', toJS(rec))
        )
        break
      case 'PERF':
        commit('SET_ACTIVE', 'performance')
        base('Performances').find(payload.id, (err, rec) =>
          dispatch('performance/setup', toJS(rec))
        )
        break
      case 'PLAY':
        commit('SET_ACTIVE', 'play')
        base('Plays').find(payload.id, (err, rec) =>
          dispatch('play/setup', toJS(rec))
        )
        break
      case 'TROUPE':
        commit('SET_ACTIVE', 'troupe')
        base('Troupes').find(payload.id, (err, rec) =>
          dispatch('troupe/setup', toJS(rec))
        )
        break
    }
  },
  inspect({commit, dispatch}, payload) {
    switch(payload.type) {
      case 'CAST':
        commit('SET_ACTIVE', 'member')
        dispatch('member/setup', payload.data)
        break
      case 'AUTHOR':
        commit('SET_ACTIVE', 'author')
        dispatch('author/setup', payload.data)
        break
      case 'PERF':
        commit('SET_ACTIVE', 'performance')
        dispatch('performance/setup', payload.data)
        break
      case 'PLAY':
        commit('SET_ACTIVE', 'play')
        dispatch('play/setup', payload.data)
        break
      case 'TROUPE':
        commit('SET_ACTIVE', 'troupe')
        dispatch('troupe/setup', payload.data)
        break
    }
  }
}

const mutations = {
  SET_ACTIVE(state, active) {
    state.active = active
  }
}

export default {
  state,
  modules: {
    performance,
    member,
    author,
    play,
    troupe
  },
  actions,
  mutations,
  namespaced: true
}
